// extracted by mini-css-extract-plugin
export var cookieBtn = "mainfooter-module--cookieBtn--6f95b";
export var group = "mainfooter-module--group--94c65";
export var groupFollow = "mainfooter-module--groupFollow--294ce";
export var groupMmd = "mainfooter-module--groupMmd--e30b8";
export var iconFigOne = "mainfooter-module--icon-fig-one--6335c";
export var iconYoutube = "mainfooter-module--icon-youtube--2cb01";
export var inner = "mainfooter-module--inner--28bc6";
export var legal = "mainfooter-module--legal--1966b";
export var links = "mainfooter-module--links--28a44";
export var questions = "mainfooter-module--questions--f9084";